export default "__VITE_ASSET__BMX422bB__"